import { render, staticRenderFns } from "./FormUserPackageImport.vue?vue&type=template&id=2618418e&scoped=true"
import script from "./FormUserPackageImport.vue?vue&type=script&lang=js"
export * from "./FormUserPackageImport.vue?vue&type=script&lang=js"
import style0 from "./FormUserPackageImport.vue?vue&type=style&index=0&id=2618418e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2618418e",
  null
  
)

export default component.exports